<template>
  <div class="throughRec-zh">
    <section class="page-content" v-if="cardInfo.tolls.length > 0">
      <div class="card-info">
        <div class="left">
          <div class="line">
            <i class="iconfont etc-icon-through-etc"></i>
            <span>{{cardInfo.card_name}}</span>
          </div>
          <div class="line">
            <i class="iconfont etc-icon-through-card"></i>
            <span>{{cardInfo.card_no | formatCard}}</span>
          </div>
          <div class="line">
            <i class="iconfont etc-icon-car"></i>
            <span>{{cardInfo.plate_no}}</span>
          </div>
        </div>
        <div class="right">
          <p class="money">-{{cardInfo.total_fee}}</p>
          <p class="tip">卡余额不足，扣费失败</p>
        </div>
      </div>
      <form id="payForm" method="post" :action="postData.url" v-if="postData.url">
        <input  type="hidden" name="charset" value="UTF-8">
        <input  type="hidden" name="jsonRequestData" v-model="postData.queryData">
      </form>
      <div class="through">
        <div class="through-item" v-for="(v, i) in cardInfo.tolls" :key="i">
          <div class="through-head" @click="changeItem(v, i)">
            <div class="left">
              <p class="location">{{v.entry_station || '未知'}}</p>
              <p class="time">{{v.entry_time || '未知'}}</p>
            </div>
            <div class="right">
              <div class="pay-status">
                <p>-{{v.actual_fee}}</p>
                <p class="status">扣费失败</p>
              </div>
              <i class="iconfont" :class="v.show?'etc-icon-arrow-up':'etc-icon-arrow-down'"></i>
            </div>
          </div>
          <div class="through-body" v-show="v.show">
            <div class="line">
              <p>
                <span>订单号</span>
                <span>{{v.payment_sn}}</span>
              </p>
            </div>
            <div class="line">
              <p>
                <span>入口站</span>
                <span>{{v.entry_station || '未知'}}</span>
              </p>
              <p class="time">
                <span>入闸时间</span>
                <span>{{v.entry_time || '未知'}}</span>
              </p>
            </div>
            <div class="line">
              <p>
                <span>出口站</span>
                <span>{{v.exit_station || '未知'}}</span>
              </p>
              <p class="time">
                <span>出闸时间</span>
                <span>{{v.exit_time || '未知'}}</span>
              </p>
            </div>
          </div>
          <div class="through-btn" v-show="v.show" @click="pay(v.id)">立即支付</div>
          <!-- <div class="through-btn"  @click="pay(v.id)">立即支付</div> -->
        </div>
      </div>
    </section>
    <section class="page-content empty" v-else>
      <img class="no-data" src="https://wecos.etczs.net/bill/rec-no-data.png" />
      <div class="no-data-title" >暂无待还款记录</div>
    </section>
    <section class="page-bottom"></section>
  </div>
</template>

<script>
// mixins
import FunMixin from '@/mixins/funMixin'
// api
import ApplyApi from '@/api/apply.api'
import ETC from '@/config/etc.config'

export default {
  name: 'throughRec-zh',
  mixins: [FunMixin],
  components: {},
  data() {
    return {
      postData: {
        url: '',
        queryData: ''
      },
      cardInfo: {tolls: []}
    }
  },
  computed: {},
  methods: {
    async pay(toll_id) {
      this.m_showLoading()
      try {
        const res = await ApplyApi.getZHRepay({recordId: toll_id})
        if (res && res.url) {
          // location.href = res.payment_info.url + '&jsonRequestData=' + res.payment_info.queryData
          this.postData = res
          setTimeout(() => {
            console.log(this.postData);
            document.getElementById('payForm').submit()
          })
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.m_loadingClose()
      }
    },
    changeItem(item, i) {
      item.show = !item.show
      this.$set(this.cardInfo.tolls, i, item)
    }
  },
  async mounted() {
    if (this.$route.query.token) {
      localStorage.setItem(ETC.LOCAL_STORAGE_KEY.TOKEN, this.$route.query.token)
    }
    this.m_showLoading()
    try {
      const res = await ApplyApi.getZHThrough()
      if (res && res[0]) {
        res[0].tolls[0] && (res[0].tolls[0].show = true)
        this.cardInfo = res[0]
      }
    } catch (e) {
    } finally {
      this.m_loadingClose()
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../style/cool.practical";

.throughRec-zh {
  background-color: #f5f5f5;
  .page-content {
    .card-info{
      height: 232px;
      background-color: #fff;
      padding: 0 40px 0 30px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left{
        .line{
          margin-top: 16px;
          display: flex;
          align-items: center;
          i{
            font-size: 40px;
            margin-right: 16px;
          }
          span{
            font-size: 32px;
          }
          &:first-child{
            margin-top: 0;
          }
        }
      }
      .right{
        .money{
          font-size: 60px;
          font-weight: bold;
          text-align: right;
        }
        .tip{
          font-size: 24px;
          color: #F94E36;
          text-align: right;
          margin-top: 12px;
          white-space: nowrap;
        }
      }
    }
    .through{
      padding: 0 20px 20px;
    }
    .through-item{
      border-radius: 12px;
      overflow: hidden;
      margin-top: 20px;
      box-shadow:0 4px 12px 0 rgba(0,0,0,0.05);
      .through-head{
        height: 128px;
        padding: 0 20px;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .location{
          font-size: 32px;
        }
        .time{
          font-size: 24px;
          color: #999999;
          margin-top: 4px;
        }
        .right{
          display: flex;
          align-items: center;
        }
        .pay-status{
          text-align: right;
          font-size: 32px;
          .status{
            font-size: 24px;
            color: #999999;
          }
        }
        .iconfont{
          font-size: 36px;
          color: #999999;
          margin-left: 20px;
        }
      }
      .through-body{
        color: #fafafb;
        padding: 0 20px;
        .line{
          font-size: 28px;
          color: #666666;
          padding: 20px 0;
          border-bottom: 1px solid #dddddd;
          p{
            display: flex;
            justify-content: space-between;
            &.time{
              font-size: 24px;
              color: #999999;
              margin-top: 4px;
            }
          }
          &:last-child{
            border-bottom: none;
          }
        }
      }
      .through-btn{
        height: 80px;
        line-height: 80px;
        color: $primary-color;
        font-size: 28px;
        text-align: center;
        border-top: 1px solid #dddddd;
      }
    }
  }
  .empty {
    padding-top: 80rpx;
    .no-data {
      margin: 0px auto 0;
      display: block;
      width: 568px;
      height: 320px;
    }
    .no-data-title {
      font-size: 32rpx;
      line-height: 48rpx;
      color: #666;
      text-align: center;
      margin-top: 24rpx;
    }
  }
  .page-bottom {
  }
}
</style>
